// extracted by mini-css-extract-plugin
export default {"label":"PhoneInput_label__s7mjx","wrapper":"PhoneInput_wrapper__kjd7h"};